<mic-spinner-overlay ariaLabel="loading" color="primary" [loading]="isLoadingData || isSavingData">
  <h1>{{ 'forecast.title' | translate }}</h1>
  <div id="description1">{{ 'forecast.description' | translate }}</div>
  <mat-card id="card">
    <mat-card-content>
      @if (sizes && sizes.length !== 0) {
        <tkc-modification-buttons [isModificationsPending]="isModificationPending"
                                  [saveModifications]="saveModifications.bind(this)"
                                  [resetModifications]="resetModifications.bind(this)"/>
        <div id="screen-actions" class="card-margin-right-and-left">
          <app-autocomplete
            [placeholder]="'forecast.card.actions.filter.size' | translate"
            [label]="('forecast.card.actions.filter.size' | translate)"
            [filterCtrl]="sizesFilterCtrl"
            [filteredList$]="filteredSizes$"
            [isLoading]="isSizesLoading"
            (elementSelected)="onElementSelected($event)"/>
          <div id="action-buttons">
            <button mat-icon-button class="color-primary mic-icon-button-large" (click)="openForecastDetailsHelpModal()">
              <mat-icon class="color-primary">help</mat-icon>
            </button>
            <button mat-flat-button color="primary" (click)="copyAllFitment()">
              <span>{{ 'forecast.card.actions.copyAllFitment' | translate }}</span>
            </button>
            <button mat-flat-button color="primary" (click)="copyAllProposedReplenishment()">
              <span>{{ 'forecast.card.actions.copyAllReplenishment' | translate }}</span>
            </button>
          </div>
        </div>
        <div class="year-scroller-display">
          <div class="year-scroller">
            <mic-year-scroller [(year)]="year" [leftDisabled]="true" [rightDisabled]="true" />
          </div>
        </div>
        <div class="forecast-table-scroll-wrapper card-margin-right-and-left">
          <mic-forecast-table [(year)]="year"
                              [size]="selectedSize"
                              [siteId]="siteId"
                              [(isLoadingData)]="isLoadingData"
                              [(isSavingData)]="isSavingData"
                              [(isModificationPending)]="isModificationPending"
          />
        </div>
        <div class="year-scroller-display">
          <div class="year-scroller-filler"></div>
          <div class="year-scroller">
            <mic-year-scroller [(year)]="year" [leftDisabled]="true" [rightDisabled]="true" />
          </div>
        </div>
        <div id="legend-bottom" class="card-margin-right-and-left">
          <div id="legend-red-point">
            <div id="input-edited-marker"></div>
            <span>{{ 'common.legend.redPoint' | translate }}</span>
          </div>
          <div id="legend-frozen-zone">
            <div id="frozen-zone"></div>
            <span>{{ 'common.legend.frozenZone' | translate }}</span>
          </div>
          <div id="legend-filler"></div>
        </div>
      }
      @else {
        <div class="no-data">
          <tkc-no-data></tkc-no-data>
        </div>
      }
    </mat-card-content>
  </mat-card>
</mic-spinner-overlay>


